import bwipjs from 'bwip-js';
import { http } from "@/helpers/http";

function textToImage(options) {
    try {
        let canvas = document.querySelector("#canvas");
        bwipjs.toCanvas(canvas, options);
        return canvas.toDataURL('image/png')
    } catch (e) {
        console.log(e)
        return null
    }
}

function preProcess(orderDetails, printer) {

    try {
        // shipping method - convert to lowercase
        orderDetails.shippingMethod = orderDetails.shippingMethod.toLowerCase();

        // products
        if (orderDetails.products) orderDetails.products = Object.fromEntries(
            Object.entries(orderDetails.products).sort(([, a], [, b]) => a.sortIndex - b.sortIndex)
        );

        // sokochan order id
        if (!orderDetails.sokochanOrderId) orderDetails.sokochanOrderId = "N/A";

        // tracking No
        if (!orderDetails.trackingNo) orderDetails.trackingNo = "N/A";

        if (!orderDetails.sortingCode) orderDetails.sortingCode = "";

        // remarks
        if (!orderDetails.remarks) orderDetails.remarks = "";
        else {
            if (printer !== "proship_v3")
                orderDetails.remarks = "หมายเหตุ: " + orderDetails.remarks;
            else orderDetails.remarks = orderDetails.remarks;
        }

        if (!printer || printer && (printer !== "x100"))
            orderDetails.remarks = orderDetails.remarks.replace(/\//g, "\n");

        // fb/line
        if (orderDetails.customer && orderDetails.customer.showSocialLinkOnLabel) {
            if (printer !== 'proship_v3p')
                orderDetails.remarks += " " + ": " + orderDetails.customer.socialLink;
        }

        // address
        if (orderDetails.customer && orderDetails.customer.address) {
            if (!orderDetails.customer.address.address)
                orderDetails.customer.address.address = "";
            if (!orderDetails.customer.address.district)
                orderDetails.customer.address.district = "";
            if (!orderDetails.customer.address.subDistrict)
                orderDetails.customer.address.subDistrict = "";
            if (!orderDetails.customer.address.province)
                orderDetails.customer.address.province = "";
            if (!orderDetails.customer.address.zipcode)
                orderDetails.customer.address.zipcode = "     ";

            orderDetails.customer.address.address = orderDetails.customer.address.address.replace(/􀀀/g, "");
            orderDetails.customer.address.district = orderDetails.customer.address.district.replace(/􀀀/g, "");
            orderDetails.customer.address.subDistrict = orderDetails.customer.address.subDistrict.replace(/􀀀/g, "");
            orderDetails.customer.address.province = orderDetails.customer.address.province.replace(/􀀀/g, "");
        }

        // label top logo
        orderDetails.logo = "logo_" + orderDetails.shippingMethod.toLowerCase() + ".png";

        if (orderDetails.codAmount && typeof orderDetails.codAmount == "string") {
            orderDetails.codAmount = parseFloat(orderDetails.codAmount.replace(/\D/g, ''));
        }

        if (orderDetails.shippingMethod.includes("kerry")) {
            if (orderDetails && orderDetails.customer && orderDetails.customer.phoneNo) {
                orderDetails.customer.phoneNo = orderDetails.customer.phoneNo.replace(/\d{4}$/, "xxxx");
            }
            if (orderDetails && orderDetails.shop && orderDetails.shop.phoneNo) {
                orderDetails.shop.phoneNo = orderDetails.shop.phoneNo.replace(/\d{4}$/, "xxxx");
            }
        }

        return orderDetails;
    } catch (e) {
        console.log("ERROR preprocess", e);
        return orderDetails;
    }
};

function generateLabel(order) {
    order = preProcess(order);
    const RENDERER = {
        "kerry": () => {
            let cust = order.customer;
            let zipChars = (cust.address.zipcode + "").split("");
            let receiverInfoTxt = `${cust.name} (${cust.phoneNo || cust.mobileNo || ""
                }) <br> ${cust.address.address} <br> ${cust.address.subDistrict}, ${cust.address.district
                } <br> ${cust.address.province}  <br> ${cust.address.zipcode}`;
            let shop = order.shop;
            let senderInfoTxt = [
                shop.name,
                `(${shop.phoneNo})`,
                shop.address.address,
                shop.address.district,
                shop.address.subDistrict,
                shop.address.province,
                shop.address.zipcode
            ].filter(a => a).join("<br>")

            let itemListTxt = "";
            for (const sku in order.products) {
                itemListTxt += `${order.products[sku].sku || sku} ${order.products[sku].name} x ${order.products[sku].qty} <br>`;
            }
            let currentDateTime = new Date().toLocaleString("en-GB", { day: "numeric", month: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(",", "");

            let html = `
        <div style="width: 3.74in; box-sizing: border-box; height: 5.75in; margin: 0.010in; border: 1px solid black;">
                    <table
                           style="border-collapse:collapse; width: 100%; text-align: center;">
                        <tr>
                            <td rowspan="2" style="border: 1px solid black;">
                                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAABSCAYAAADzVUKHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAArQSURBVHgB3ZwFbBRfF8VvS/+4uwZ31+Aa3N3d3V0CTdDiBIIFCcGd4O7u2uISQoCgwW2//l4yTb+ybWd25+2WnqSBbmdHztx335Xzno8jGOJFcPkPHz7I7du35fTp0/L06VP1Wbp06aRUqVJSpEgRSZAggXgbfuJFfPz4UZYuXSpr1qyRR48eOT0ma9asUqNGDRk4cKAkSZJEvAUfb1jUt2/fZN++fTJy5Eh5+fKlqe8kT55chg4dKq1bt5Y4ceKIp+FRon79+iUHDx6UKVOmyM2bN8XqpX18fKRAgQLSp08fqV+/vsSIEUM8BY8QBUGXL1+WefPmyYEDB+Tnz5/iDvz8/KRq1arSu3dvKV68uPpdN7QTxTAbPny4rF+/3m2CwgKCWrRoIX379pVs2bKJTmgn6ujRo9KkSRPReRmcfLdu3aRLly6SNGlS0QFf0QwI0j263717J1OnTpUqVarI5s2b5cuXL2I3tBPl66v9EiEgBuvRo4fUqVNHjh07ZusL0v4UzFSexJ8/f+TatWtquLdv314uXryoPnMX0Y4oA5Cza9cuZV0DBgyQt2/fijuItkQZYKZdvXq1CiOmT58uT548EVdgiSjioefPn1v5imUfFStWLC2R9/v372Xy5MlqOG7cuFF+//5t6fumngKCTp48KbVq1VKRMVPxq1evzHzVtEXFjBlTGjduLOfPn1d+hak+duzYYjdu3LihHH758uXl8OHDpmO7SOOoO3fuyNy5c2XLli3y48ePkM9TpEghHTt2VOlERNn92bNnpXbt2uH+HYsrV66cDBo0SMqUKRNCLLd14cIFCQgIULGYHQ45LOLHj68I49qFCxeO8NhwiSKbnz9/vqxYsSJCM02WLJkMGTJE2rVrJ3Hjxv3r71hIzZo1//ocgnLlyiUTJ06UsmXLRjhEmcUGDx4s169ftzxkzIBrY83+/v6SMmVKp8f8RdSnT59k4cKFqvxhNrPHCgoWLKjeDMMzdLLqjKg0adIo8+/UqZNTcp2BmhVDZdq0aXL37l3RAWOUkENibaERQtTXr19l+/btyuERuLmKChUqyNixY6Vo0aLqd/xN9erV1f8TJ04sjRo1knHjxrlcjGP4c48rV65U5OkAVsUzNGjQIORF+gQ7M8e2bdtk0aJFcunSJVuiWd5G5cqVZdSoUcpC8VF169aVYcOGSfbs2cUOPHjwQFatWiVLlixRibfdMEYJBUNGhE+zZs0cp06dks+fP4vdYIhRbMucObPyQ3aXQ3DwlI9xE3v37rW9OgFwI4wIn+DMW5mQ3YlrpkyZlEU1bNhQe70IB3/kyBGZMGGCBAYGapkhQ4gy4A5hmGv69OlVnEWulTp1avEkvn//Ljt27FAR+P3798VO/EWUAauEEU23atVKxVVYkzfBbD1z5kw1Ob1+/VrsQLhEATNkYUUknsRS+fLl82hZJSJw7/fu3ZM5c+aoGpW7/ssnuCIYaZHT2d8hpFixYjJmzBgVUUcVgpyBQJWGxqFDh1Q65gpMEWXAOI7mJHEG0awnCvt2AIdPi4xMAIdvFTGCfct4swczzIhc161bJ4UKFbLdihgedGlwxPg5O8/PuYjhqB7g9MkYLH1fLCJPnjxayiAEkASkzZs3V6kNLyQoKEjsBiMgsgTYGbzuWF68eKE6xugMFi9erHwIqQnVCoptBKxmSzpm4Urj1NdbFUg6JRBDiYUyjrPMAL+yYMECqVixojoGrYIdcGVIe9yi8A/4IepA5FFYVGSgfIvVlShRQjVS3W1HuWRR4iGQVlAlbdq0qaogUBC0imfPnin/RZK9e/dul6f6KDv0CPzwNUTuxDLu5mLMWB06dFAzmCuEuxLSaCfq8ePHquRCMfDNmzdiF/BplIcqVaqkyi1WYMWi8GeUW7QPPXItalK8RTtfCg9AQwKHb7WAZ+Y+IJPMY/ny5SpQ1R5WM8y4MS7MD37F3bo3pP/3338hs5fVWSwyohB9MNHgKgyVn3aiwpLCQxqEWfVVYQkyYJelYqE9e/aUrl27qhJR6PN6nCjADfDA5I5mCDOGmV0Ku7DEci/Ux2kq5M+f3+l3/HQ784gSboMwiIIwZ8fSOYagiO7TKoHGufgXP0QlNrKWmXaLMhPrGBYT2rog0O4JwADnRJZNbommyoyP84gzNwuIwap0EWSAVj3qYkILsxOB9vDA6gwHQVZJsno8LwPdJ/p1pn7SqsigPeDU0RGxC+fOnVPRPc2QyJoR2onSoRUIC3cKfET4lHQo8/Tr1y/cko72oecJi7LjZdNtJgrHb6GgCVuh0E6Uqxm+Fdg5KtBdoGopXbq0yiXRZIBoYVE6QGm6c+fOKhClXa/dRxGndO/eXYtQHjEI6YahlrEbKGfOnDmjnL12iyKpRKZDq5uFPkTadgBydu7cqdpPadOmFbthJPLEdDh8j1U46d4sW7ZMNm3apGrgrlgyJKO74hzIlDin3Qhd6Qg9m3q0e8lN0FXmYVHm0u5++PChqe9mzJhR+YzwJJB2AGLCyxu90oUhhWjbtq2SGtJxRokXHvBD6Br279+v5Iw6SIIDo/wTHrza10uYMKEqkCEGgwSEswYgk2YoimCSVx3LZA2CzOSWUUI4QJFs0qRJqmGAvpPW+ogRI1QJRIfFk+uF9UGRIUopLHLkyKF0DbpAA3Xt2rVKO2U17fHzho/yBtCpIr0+ceKEuAI/ZMw6FgJGBTDEbt26pYY10bWrYELxy5Ili2nh/b8EusqEHww1I19zFYQmvqz2jk5gFRWCDsQfBLjukgSqVasmvqzyDj0t/6uAENbtkFuOHz/eNuWLsezDl6mZpFWXU6dwp3PxNQThqHnhKF7C27rEVXBepJhqjuzVq5da7KMDbAxB4HjlyhWxG+gayOxRxzCbmal9WwFuiVYWUESRFiCiaNmype2WRfC4Z88etRamf//+qs7jroWhl+IBEH+wbtjupR1wUK9ePZk9e3ZItSMk6ooXL56aJfhhJrQbCClwrvgQnC1O1yoQe6DSw7nyYl05R2Rg/Q7hBGsV+b+B/wtPyXnatGmjFHG8sbBr1uwA0h9Dm85SMrPWRWmFVU6kNnatRggNLIeckkQdn43hhIbTOJ4ElIydZWnkXySvdoPaNMtBWPXADkDOpnFIZKMH1tXgiwge7QbJNypArsNLSJUqldPjIkx4mBrJi1DJ4TB14Pjx42pmoXN79erVkM/xQ/TckN7wlnUAHSmVV1wBeWZEML2JDdM8rGOiDBuzoIRitqaN3gBy+HfDhg22xUJhwUp7Jha0oGgezED7bj9WiDIAUTqAc6aV7kqV9N9YyOIm8Ln4QyLsiKqpESFaE4WbIH7DisITiJlFtCSKgJGomnp83rx5xQ5EO6JYQTV69Ggl6THrqM0g2hCVIUMG1aCgc6xjDaF2oojFEiVKpG0zBwJEsgmiafbq1AWPbC+JSGvGjBmydetWU/srmAkPyBbIG2l35cyZU1tIYcBjG5YSsJISkXASaUd02cgeumTJkmqNMIGjp+DxLXARbJHbzZo1S2175OzyzohiJsudO7faho2I2tPb4Hplr2BAkY2SCeWSsJvmhCUKP0fKQRveaztRO7yM4A6Qw9/f3xHslB3BZR31w14M/AQ7Z0dAQIA6xtvwOlEGAgMDHV26dHEE52OOYAty9OzZ0xEUFOSIKvDa0AsPbPUGkAbpnsms4H+Z8Ct5QkMxQwAAAABJRU5ErkJggg==" width="40" />
                            </td>
                            <td style="border: 1px solid black;">
                                <span style="font-size: 16px; font-weight: bold;">${order.shipperInfo ? order.shipperInfo.presortOption : ""}</span>
                            </td>
                            <td style="border: 1px solid black; line-height: 10px">
                                <span style="font-size: 10px;">DC</span>
                                    <br>
                                    <span style="font-size: 12px; font-weight: bold;">
                                    ${order.shipperInfo ? order.shipperInfo.dc : ""}
                                </span>
                            </td>
                            <td rowspan="3" colspan="2" style="border: 1px solid black;">
                                <img style="margin-bottom: -7px" src="${textToImage({
                bcid: 'qrcode',
                text: order.trackingNo,
                scale: 2,
            })}"/>
                                </td>
                        </tr>
                        <tr>
                            <td style="border: 1px solid black;">
                                <span style="font-size: 16px; font-weight: bold;">${order.shipperInfo ? order.shipperInfo.serviceCode : ""}</span>
                            </td>
                            <td style="line-height: 10px; border: 1px solid black;">
                                <span style="font-size: 10px;">DEL ROUTE</span>
                                <br>
                                <span style="font-size: 12px; font-weight: bold;">
                                ${order.shipperInfo ? order.shipperInfo.delRoute : ""}
                                </span>
                            </td>
                        </tr>
                        <tr>
          
        
                            <td colspan="3" style="text-align: center; border: 1px solid black;">
                                                    <img style="margin-bottom: -7px" src="${textToImage({
                bcid: "code128",
                text: order.trackingNo,
                scale: 1,
                height: 11,
            })}"/>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" style="border: 1px solid black;">
                                <span style="font-size: 16px; font-weight: bold;">${order.trackingNo}</span>
                            </td>
                            <td style="border: 1px solid black;">
                                <span style="font-size: 16px; font-weight: bold;">
                                    ${order.codAmount && order.codAmount > 0 ? "COD" : ""}
                                </span>
                            </td>
                            <td style="border: 1px solid black;">
                                <span style="font-size: 16px; font-weight: bold;">1 OF 1</span>
                            </td>
                        </tr>
                    </table>
        
                    <table border="0"
                           style="border-collapse:collapse; width: 100%;">
                        <tr>
                            <td style="font-size: 12px; border: 1px solid black;">
                                ${senderInfoTxt}
                            </td>
        
                            <td valign="top" style="font-size: 12px; padding-left: 0.15in; border: 1px solid black;">
                                ${receiverInfoTxt}
                            </td>
                        </tr>
                        <tr>
                        <td style="font-size: 16px;">
                            ${order.codAmount ? `เก็บเงิน: ${order.codAmount}` : ''}
                        </td>
                            <td colspan="2"
                                style="text-align: right; font-size: 12px">
                                ${currentDateTime}
                                </td>
                        </tr>
                        <tr>
                            <td>
                                <span style="font-size: 16px; font-weight: bold;">${order.customer.address.subDistrict}</span>
                            </td>
                            <td>
                                <table
                                       style="border-collapse:collapse; width: 100%; text-align: center; font-size: 16px; font-weight: bold;">
                                    <tr>
                                        ${zipChars.map(c => `<td style="border: 1px solid black;">${c}</td>`).join("")}
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </table>

                    <p style="margin: 0; font-size: 16px; font-weight: bold; border-top: 1px solid black; border-bottom: 1px solid black;">
                        ${order.shipperInfo ? order.shipperInfo.lineHual : ""}
                    </p>
              
                    <p style="font-size: 12px; border-bottom: 1px solid black;">
                        ${order.remarks}
                    </p>
             

                    <p style="font-size: 12px; padding-left: 2px;">
                        ${itemListTxt}
                    </p>
                </div>`

            return html
        },

        "thaipost": () => {
            let cust = order.customer;
            let receiverInfoTxt = [
                `${cust.name} (${cust.phoneNo})`,
                cust.address.address,
                cust.address.subDistrict,
                cust.address.district,
                cust.address.province
            ].filter(a => a && a.length).join("<br>")

            let shop = order.shop;
            let senderInfoTxt = [
                shop.name,
                `(${shop.phoneNo})`,
                shop.address.address,
                shop.address.district,
                shop.address.subDistrict,
                shop.address.province,
                shop.address.zipcode
            ].filter(a => a && a.length).join("<br>")

            let shopSocialLinksTxt = "";
            if (shop.socialLinks) {
                Object.keys(shop.socialLinks).forEach(
                    (key) => (shopSocialLinksTxt += shop.socialLinks[key] + "\n")
                );
            }

            let productsHtml = "";
            let c = 0;
            for (const sku in order.products) {
                if (c % 2 === 0) productsHtml += `<tr>`
                productsHtml += `<td> ${order.products[sku].sku || sku} ${order.products[sku].name} x ${order.products[sku].qty} </td>`;
                if (c % 2 !== 0) productsHtml += `</tr>`
                c++;
            }

            let currentDateTime = new Date().toLocaleString("en-GB", { day: "numeric", month: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(",", "");

            let html = `
        <div style="position: relative; width: 3.74in; box-sizing: border-box; height: 5.75in; margin: 0.010in; border: 1px solid black; padding: 2px">
                    <table border="0"
                           style="border-collapse:collapse; width: 100%; text-align: center;">
                        <tr>
                            <td style="width: 60%; text-align: left;">
                            <img src="https://app.proship.co.th/img/thaipost.f44555ee.png" height="40" />

                            <p style="font-weight: bold; font-size: 14px"> ผู้ส่ง </p>
                            <p style="font-size: 12px; line-height: 16px; margin-bottom: 4px;"> 
                                ${senderInfoTxt}
                            </p>

                            <p style="margin-bottom: 0;">
                                ผู้รับ โทร (${cust.phoneNo})
                            </p>

                            <p style="font-size: 12px; margin-top: 4px">
                                ${receiverInfoTxt}
                            </p>
                            
                            </td>

                            <td valign="top" align="right">
                                <div style="border: 1px solid black; padding: 2px; text-align: center; font-size: 8px">
                                    บริการจัดส่งสินค้า (e-Commerce)
                                    <br>
                                    ใบอนุญาตสำาหรับลูกค้าธุรกิจ
                                    <br>
                                    <span style="font-weight: bold"> ${order.licenseNo || "รล. 00/2563"} </span>
                                    <br>
                                    ชำาระค่าฝากส่งตามที่ ปณท กำาหนด
                                </div>

                                 <div style="border: 1px solid black; padding: 2px; margin-top: 3px; text-align: center; font-size: 8px">
                                    ทำารายการผ่านระบบ PROSHIP
                                </div>

                                <table style="margin-top: 0.9in">
                                    <tr>
                                        <td align="right">
                                            <div style="height: 70px; width: 70px; background-color: black; color: white; text-align: center; line-height: -1px; font-size: 50px;">
                                    ${order.trackingNo.charAt(0)}
                                </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="right">
                                            <span style="font-size: 32px"> ${cust.address.zipcode} </span>
                                        </td>
                                    </tr>
                                </table>

                            </td>
                        </tr>
                    </table>

                    <!-- products -->
                    <p style="margin: 0; font-size: 12px; font-weight: bold; padding-left: 2px;"> รายการสินค้า </p>
                    <table style='font-size: 11px; width: 100%' cellpadding="0" cellspacing="0">
                        ${productsHtml}
                    </table>

                    <div style="width: 100%; border-bottom: 1px solid black; font-size: 12px; height: 0.5in; margin-top: 10px;">
                        ${order.remarks}
                    </div>
                    

                    <div style="position: absolute; bottom: 0; left: 0; padding-left: 20px; padding-right: 20px">
                        
                        <div style="display: flex; justify-content: space-between; ">
                            <p style="font-size: 8px; margin: 0;"></p>
                            <p style="font-size: 12px; margin: 0;">${currentDateTime}</p>
                        </div>

                        <img src="${textToImage({
                bcid: "code128",
                text: order.trackingNo,
                scale: 2,
                height: 8,
            })}" />
                        <p style="font-weight: bold; font-size: 16px; margin-bottom: 0; margin-top: -6px;"> ${order.trackingNo} </p>
                    </div>
                </div>`

            return html
        },

        "thaipost-cod": () => {
            let cust = order.customer;
            let receiverInfoTxt = [
                `${cust.name} (${cust.phoneNo})`,
                cust.address.address,
                cust.address.subDistrict,
                cust.address.district,
                cust.address.province
            ].filter(a => a && a.length).join("<br>")

            let shop = order.shop;
            let senderInfoTxt = [
                shop.name,
                `(${shop.phoneNo})`,
                shop.address.address,
                shop.address.district,
                shop.address.subDistrict,
                shop.address.province,
                shop.address.zipcode
            ].filter(a => a && a.length).join("<br>")

            let shopSocialLinksTxt = "";
            if (shop.socialLinks) {
                Object.keys(shop.socialLinks).forEach(
                    (key) => (shopSocialLinksTxt += shop.socialLinks[key] + "\n")
                );
            }

            let productsHtml = "";
            let c = 0;
            for (const sku in order.products) {
                if (c % 2 === 0) productsHtml += `<tr>`
                productsHtml += `<td> ${order.products[sku].sku || sku} ${order.products[sku].name} x ${order.products[sku].qty} </td>`;
                if (c % 2 !== 0) productsHtml += `</tr>`
                c++;
            }



            let currentDateTime = new Date().toLocaleString("en-GB", { day: "numeric", month: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(",", "");

            let html = `
        <div style="position: relative; width: 3.74in; box-sizing: border-box; height: 5.75in; margin: 0.010in; border: 1px solid black; padding: 2px">
                    <table border="0"
                           style="border-collapse:collapse; width: 100%; text-align: center;">
                        <tr>
                            <td style="width: 60%; text-align: left;">
                                <img src="https://app.proship.co.th/img/thaipost.f44555ee.png" height="40" />

                                <p style="font-weight: bold; font-size: 14px"> ผู้ส่ง </p>
                                <p style="font-size: 12px; line-height: 16px; margin-bottom: 4px;"> 
                                    ${senderInfoTxt}
                                </p>
                            </td>

                            <td valign="top" align="right">
                                <div style="border: 1px solid black; padding: 2px; text-align: center; font-size: 8px">
                                    บริการจัดส่งสินค้า (e-Commerce)
                                    <br>
                                    ใบอนุญาตสำาหรับลูกค้าธุรกิจ
                                    <br>
                                    <span style="font-weight: bold"> ${order.licenseNo || "รล. 00/2563"} </span>
                                    <br>
                                    ชำาระค่าฝากส่งตามที่ ปณท กำาหนด
                                </div>

                                 <div style="border: 1px solid black; padding: 2px; margin-top: 3px; text-align: center; font-size: 8px">
                                    ทำารายการผ่านระบบ PROSHIP
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td colspan="2">
                                <div style="width: 98.5%; text-align: center; font-size: 16px; border: 1px solid black; padding: 2px;">
                                    COD แดง เก็บเงินปลายทาง
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td valign="top" align="left">
                                <p style="margin: 0;">
                                    ผู้รับ โทร (${cust.phoneNo})
                                </p>
                                <p style="font-size: 12px; margin-top: 4px; margin-bottom: 0;">
                                    ${receiverInfoTxt}
                                </p>
                            </td>

                            <td valign="top" align="right">
                                  <table>
                                    <tr>
                                        <td align="right">
                                            <div style="height: 70px; width: 70px; background-color: black; color: white; text-align: center; line-height: -1px; font-size: 50px;">
                                    ${order.trackingNo.charAt(0)}
                                </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="right">
                                            <span style="font-size: 32px"> ${cust.address.zipcode} </span>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </table>

                    <div style="width: 98%; text-align: center; font-size: 16px; border: 1px solid black; padding: 2px;">
                                COD &nbsp; &nbsp; &nbsp; เก็บเงิน &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ฿${order.codAmount}
                            </div>

                    <!-- products -->
                    <p style="margin: 0; font-size: 12px; font-weight: bold; padding-left: 2px;"> รายการสินค้า </p>
                    <table style='font-size: 11px; width: 100%' cellpadding="0" cellspacing="0">
                        ${productsHtml}
                    </table>

                    <div style="width: 99%; border: 1px solid black; font-size: 10px; margin-top: 5px;">
                        ${order.remarks.length > 180 ? order.remarks.slice(0, 180) : order.remarks}
                    </div>

                    <div style="position: absolute; bottom: 0; left: 0; padding-left: 20px; padding-right: 20px">
                        <div style="display: flex; justify-content: space-between; ">
                            <p style="font-size: 8px; margin: 0;"> Wallet ID เบอร์ผู้ส่ง: ${shop.walletId} </p>
                            <p style="font-size: 12px; margin: 0;">${currentDateTime}</p>
                        </div>

                        <img src="${textToImage({
                bcid: "code128",
                text: order.trackingNo,
                scale: 2,
                height: 8,
            })}" />
                        <p style="font-weight: bold; font-size: 16px; margin-top: -6px; margin-bottom: 0;"> ${order.trackingNo} </p>
                    </div>
                </div>`

            return html
        },

        "thaipost0": () => {
            let cust = order.customer;
            let receiverInfoTxt = [
                `${cust.name} (${cust.phoneNo})`,
                cust.address.address,
                cust.address.subDistrict,
                cust.address.district,
                cust.address.province
            ].filter(a => a && a.length).join("<br>")

            let shop = order.shop;
            let senderInfoTxt = [
                shop.name,
                `(${shop.phoneNo})`,
                shop.address.address,
                shop.address.district + " " + shop.address.subDistrict,
                shop.address.province,
                shop.address.zipcode
            ].filter(a => a && a.length).join("<br>")

            let shopSocialLinksTxt = "";
            if (shop.socialLinks) {
                Object.keys(shop.socialLinks).forEach(
                    (key) => (shopSocialLinksTxt += shop.socialLinks[key] + "\n")
                );
            }


            let productsHtml = "";
            let c = 0;
            for (const sku in order.products) {
                if (c % 2 === 0) productsHtml += `<tr>`
                productsHtml += `<td> ${order.products[sku].sku || sku} ${order.products[sku].name} x ${order.products[sku].qty} </td>`;
                if (c % 2 !== 0) productsHtml += `</tr>`
                c++;
            }



            let currentDateTime = new Date().toLocaleString("en-GB", { day: "numeric", month: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(",", "");

            let html = `
        <div style="width: 3.74in; box-sizing: border-box; height: 5.75in; margin: 0.010in; border: 1px solid black; padding: 2px">
                    <table border="0"
                           style="border-collapse:collapse; width: 100%; text-align: center;">
                        <tr>
                            <td style="width: 60%; text-align: left;">
                             <img src="https://app.proship.co.th/img/thaipost.f44555ee.png" height="40" />


                            <p style="font-weight: bold; font-size: 14px"> ผู้ส่ง </p>
                            <p style="font-size: 12px; line-height: 16px; margin-bottom: 4px;"> 
                                ${senderInfoTxt}
                            </p>

                            <p style="margin-bottom: 0;">
                                ผู้รับ โทร (${cust.phoneNo})
                            </p>

                            <p style="font-size: 12px; margin-top: 4px">
                                ${receiverInfoTxt}
                            </p>
                            
                            </td>

                            <td valign="top" align="right">
                                <img src="https://app.proship.co.th/img/eps.8f4cedf9.png" width="90" />

                                <table style="margin-top: 0.9in">
                                    <tr>
                                        <td align="right">
                                            <div style="height: 70px; width: 70px; background-color: black; color: white; text-align: center; line-height: -1px; font-size: 50px;">
                                    ${order.trackingNo.charAt(0)}
                                </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="right">
                                            <span style="font-size: 32px"> ${cust.address.zipcode} </span>
                                        </td>
                                    </tr>
                                </table>

                            </td>
                        </tr>
                    </table>

                    <!-- products -->
                    <p style="margin: 0; font-size: 12px; font-weight: bold; padding-left: 2px;"> รายการสินค้า </p>
                    <table style='font-size: 11px; width: 100%' cellpadding="0" cellspacing="0">
                        ${productsHtml}
                    </table>

                    <div style="width: 100%; border-bottom: 1px solid black; font-size: 12px; height: 0.5in; margin-top: 10px;">
                        ${order.remarks}
                    </div>
                    

                    <div style="padding-left: 20px; padding-right: 20px">
                        <p style="font-size: 12px; margin: 0; text-align: right;">${currentDateTime}</p>
                        <img src="${textToImage({
                bcid: "code128",
                text: order.trackingNo,
                scale: 2,
                height: 8,
            })}" />
                        <p style="font-weight: bold; font-size: 16px; margin-top: -6px;"> ${order.trackingNo} </p>
                    </div>
                </div>`

            return html
        },

        "thaipost0-cod": () => {
            let cust = order.customer;
            let receiverInfoTxt = [
                `${cust.name} (${cust.phoneNo})`,
                cust.address.address,
                cust.address.subDistrict,
                cust.address.district,
                cust.address.province
            ].filter(a => a && a.length).join("<br>")

            let shop = order.shop;
            let senderInfoTxt = [
                `${shop.name} (${shop.phoneNo})`,
                shop.address.address,
                shop.address.district + " " + shop.address.subDistrict,
                shop.address.province,
                shop.address.zipcode
            ].filter(a => a && a.length).join("<br>")

            let shopSocialLinksTxt = "";
            if (shop.socialLinks) {
                Object.keys(shop.socialLinks).forEach(
                    (key) => (shopSocialLinksTxt += shop.socialLinks[key] + "\n")
                );
            }

            let productsHtml = "";
            let c = 0;
            for (const sku in order.products) {
                if (c % 2 === 0) productsHtml += `<tr>`
                productsHtml += `<td> ${order.products[sku].sku || sku} ${order.products[sku].name} x ${order.products[sku].qty} </td>`;
                if (c % 2 !== 0) productsHtml += `</tr>`
                c++;
            }


            let currentDateTime = new Date().toLocaleString("en-GB", { day: "numeric", month: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(",", "");

            let html = `
        <div style="width: 3.74in; box-sizing: border-box; height: 5.75in; margin: 0.010in; border: 1px solid black; padding: 2px">
                    <table border="0"
                           style="border-collapse:collapse; width: 100%; text-align: center;">
                        <tr>
                            <td style="width: 60%; text-align: left;">
                                <img src="https://app.proship.co.th/img/thaipost.f44555ee.png" height="40" />

                                <p style="font-weight: bold; font-size: 14px"> ผู้ส่ง </p>
                                <p style="font-size: 12px; line-height: 16px; margin-bottom: 4px;"> 
                                    ${senderInfoTxt}
                                </p>
                            </td>

                            <td valign="top" align="right">
                                <img src="https://app.proship.co.th/img/eps.8f4cedf9.png" width="90" />
                            </td>
                        </tr>

                        <tr>
                            <td colspan="2">
                                <div style="width: 98.5%; text-align: center; font-size: 16px; border: 1px solid black; padding: 2px;">
                                    COD แดง เก็บเงินปลายทาง
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td valign="top" align="left">
                                <p style="margin: 0;">
                                    ผู้รับ โทร (${cust.phoneNo})
                                </p>
                                <p style="font-size: 12px; margin-top: 4px; margin-bottom: 0;">
                                    ${receiverInfoTxt}
                                </p>
                            </td>

                            <td valign="top" align="right">
                                  <table>
                                    <tr>
                                        <td align="right">
                                            <div style="height: 70px; width: 70px; background-color: black; color: white; text-align: center; line-height: -1px; font-size: 50px;">
                                    ${order.trackingNo.charAt(0)}
                                </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="right">
                                            <span style="font-size: 32px"> ${cust.address.zipcode} </span>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </table>

                    <div style="width: 98%; text-align: center; font-size: 16px; border: 1px solid black; padding: 2px;">
                                COD &nbsp; &nbsp; &nbsp; เก็บเงิน &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ฿${order.codAmount}
                            </div>

                    <!-- products -->
                    <p style="margin: 0; font-size: 12px; font-weight: bold; padding-left: 2px;"> รายการสินค้า </p>
                    <table style='font-size: 11px; width: 100%' cellpadding="0" cellspacing="0">
                        ${productsHtml}
                    </table>

                    <div style="width: 99%; border: 1px solid black; font-size: 12px; margin-top: 5px;">
                        ${order.remarks}
                    </div>
                    

                    <div style="padding-left: 20px; padding-right: 20px">
                        <p style="font-size: 12px; margin: 0; text-align: right;">${currentDateTime}</p>
                        <img src="${textToImage({
                bcid: "code128",
                text: order.trackingNo,
                scale: 2,
                height: 8,
            })}" />
                        <p style="font-weight: bold; font-size: 16px; margin-top: -6px;"> ${order.trackingNo} </p>
                    </div>
                </div>`

            return html
        },

        "jt": () => {
            let cust = order.customer;
            let receiverInfoTxt = [
                `${cust.name} (${cust.phoneNo})`,
                cust.address.address,
                cust.address.subDistrict,
                cust.address.district,
                cust.address.province
            ].filter(a => a && a.length).join("<br>")

            let shop = order.shop;
            let senderInfoTxt = [
                shop.name,
                `(${shop.phoneNo})`,
                shop.address.address,
                shop.address.district,
                shop.address.subDistrict,
                shop.address.province,
                shop.address.zipcode
            ].filter(a => a && a.length).join("<br>")

            let shopSocialLinksTxt = "";
            if (shop.socialLinks) {
                Object.keys(shop.socialLinks).forEach(
                    (key) => (shopSocialLinksTxt += shop.socialLinks[key] + "\n")
                );
            }


            let productsHtml = "";
            let c = 0;
            for (const sku in order.products) {
                if (c % 2 === 0) productsHtml += `<tr>`
                productsHtml += `<td> ${order.products[sku].sku || sku} ${order.products[sku].name} x ${order.products[sku].qty} </td>`;
                if (c % 2 !== 0) productsHtml += `</tr>`
                c++;
            }



            let currentDateTime = new Date().toLocaleString("en-GB", { day: "numeric", month: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(",", "");

            let html = `
        <div style="width: 3.74in; box-sizing: border-box; height: 5.75in; margin: 0.010in; border: 1px solid black; padding: 2px; position: relative;">
        
        <table style="width: 100%">
            <tr>
                <td>
                    <img src="https://app.proship.co.th/img/jt.3e53e24b.png" height="40" />
                </td>
                <td valign="top" align="right">
                    <span style="font-size: 12px;">${currentDateTime}</span>
                </td>
            </tr>
        </table>

        <p style="margin: 0; text-align: center; font-size: 18px">
            ${order.trackingNo}
            <br>  
             <img src="${textToImage({
                bcid: "code128",
                text: order.trackingNo,
                scale: 3,
                height: 6,
            })}" />
        </p>
        <p style="font-size: 24px; margin-top: -10px; margin-bottom: 0; text-align: center;"> ${order.sortingCode} </p>

        <p style="font-size: 12px; line-height: 16px; margin-bottom: 4px; border-top: 1px dashed black; border-bottom: 1px dashed black; margin-top: 0;"> 
            ผู้ส่ง
            <br>
            ${senderInfoTxt}
        </p>

        <p style="margin-bottom: 0; font-size: 14px; border-bottom: 1px dashed black; margin-top: 0; position: relative;">
            ผู้รับ โทร (${cust.phoneNo})
            <br>
            ${receiverInfoTxt}

            <span style="position: absolute; bottom: 10px; right: 10px; font-size: 18px;">
                ${cust.address.zipcode}
            </span>
         </p>

         <p style="margin-bottom: 0; font-size: 12px; border-bottom: 1px dashed black; margin-top: 0;">
           ${order.remarks}
         </p>

         <table style='font-size: 11px; width: 100%' cellpadding="0" cellspacing="0">
            ${productsHtml}
         </table>
        </div>`
            return html
        },

        "jt-cod": () => {
            let cust = order.customer;
            let receiverInfoTxt = [
                `${cust.name} (${cust.phoneNo})`,
                cust.address.address,
                cust.address.subDistrict,
                cust.address.district,
                cust.address.province
            ].filter(a => a && a.length).join("<br>")

            let shop = order.shop;
            let senderInfoTxt = [
                shop.name,
                `(${shop.phoneNo})`,
                shop.address.address,
                shop.address.district,
                shop.address.subDistrict,
                shop.address.province,
                shop.address.zipcode
            ].filter(a => a && a.length).join("<br>")

            let shopSocialLinksTxt = "";
            if (shop.socialLinks) {
                Object.keys(shop.socialLinks).forEach(
                    (key) => (shopSocialLinksTxt += shop.socialLinks[key] + "\n")
                );
            }


            let productsHtml = "";
            let c = 0;
            for (const sku in order.products) {
                if (c % 2 === 0) productsHtml += `<tr>`
                productsHtml += `<td> ${order.products[sku].sku || sku} ${order.products[sku].name} x ${order.products[sku].qty} </td>`;
                if (c % 2 !== 0) productsHtml += `</tr>`
                c++;
            }



            let currentDateTime = new Date().toLocaleString("en-GB", { day: "numeric", month: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(",", "");

            let html = `
        <div style="width: 3.74in; box-sizing: border-box; height: 5.75in; margin: 0.010in; border: 1px solid black; padding: 2px; position: relative;">
        
        <table style="width: 100%">
            <tr>
                <td>
                    <img src="https://app.proship.co.th/img/jt.3e53e24b.png" height="40" />
                </td>
                <td valign="top" align="right">
                    <span style="font-size: 12px;">${currentDateTime}</span>
                </td>
            </tr>
        </table>

        <p style="margin: 0; text-align: center; font-size: 18px">
            ${order.trackingNo}
            <br>  
             <img src="${textToImage({
                bcid: "code128",
                text: order.trackingNo,
                scale: 3,
                height: 6,
            })}" />
        </p>
        <p style="font-size: 28px; margin-top: -10px; margin-bottom: 0; text-align: center;"> ${order.sortingCode} </p>

        <p style="font-size: 12px; line-height: 16px; margin-bottom: 4px; border-top: 1px dashed black; border-bottom: 1px dashed black; margin-top: 0;"> 
            ผู้ส่ง
            <br>
            ${senderInfoTxt}
        </p>

        <p style="margin-bottom: 0; font-size: 14px; border-bottom: 1px dashed black; margin-top: 0; position: relative;">
            ผู้รับ โทร (${cust.phoneNo})
            <br>
            ${receiverInfoTxt}

            <span style="position: absolute; bottom: 5px; right: 5px; font-size: 18px; line-height: 16px">
            COD
            <br>
            ฿${order.codAmount}
            <br>
            <br>
                ${cust.address.zipcode}
            </span>
         </p>

         <p style="margin-bottom: 0; font-size: 12px; border-bottom: 1px dashed black; margin-top: 0;">
           ${order.remarks}
         </p>

         <table style='font-size: 11px; width: 100%' cellpadding="0" cellspacing="0">
            ${productsHtml}
         </table>

         <div style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(-45deg);
            font-size: 120px;
            color: rgba(200, 200, 200, 0.2);
            white-space: nowrap;
            z-index: -1;
            pointer-events: none;">
            COD
        </div>

        </div>`
            return html
        },

        "shopee": () => {
            let cust = order.customer;
            let receiverInfoTxt = [
                `${cust.name} (${cust.phoneNo})`,
                cust.address.address,
                cust.address.subDistrict,
                cust.address.district,
                cust.address.province
            ].filter(a => a && a.length).join("<br>")

            let shop = order.shop;
            let senderInfoTxt = [
                shop.name,
                `(${shop.phoneNo})`,
                shop.address.address,
                shop.address.district,
                shop.address.subDistrict,
                shop.address.province,
                shop.address.zipcode
            ].filter(a => a && a.length).join("<br>")

            let shopSocialLinksTxt = "";
            if (shop.socialLinks) {
                Object.keys(shop.socialLinks).forEach(
                    (key) => (shopSocialLinksTxt += shop.socialLinks[key] + "\n")
                );
            }

            let productsHtml = "";
            let c = 0;
            for (const sku in order.products) {
                if (c % 2 === 0) productsHtml += `<tr>`
                productsHtml += `<td> ${order.products[sku].sku || sku} ${order.products[sku].name} x ${order.products[sku].qty} </td>`;
                if (c % 2 !== 0) productsHtml += `</tr>`
                c++;
            }



            let currentDateTime = new Date().toLocaleString("en-GB", { day: "numeric", month: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(",", "");

            let html = `
        <div style="width: 3.74in; box-sizing: border-box; height: 5.75in; margin: 0.010in; border: 1px solid black;">
                    <table>
                        <tr>
                            <td style="width: 30%; text-align: left;">
                                <img src="https://app.proship.co.th/img/shopee.90a9a6ae.png" height="40" />
                            </td>

                            <td style="width: 70%;">
                                <img style="width: 100%;" src="${textToImage({
                bcid: "code128",
                text: order.trackingNo,
                scale: 2,
                height: 8,
            })}" />
                                <p style="font-size: 12px; margin: 0; margin-top: -4px; text-align: center;"> ${order.trackingNo} </p>
                            </td>
                        </tr>
                    </table>

                    <table border="1" style="border-collapse:collapse; width: 100%;">
                        <tr>
                            <td style="width: 70%; padding: 2px;">
                                <p style="font-size: 12px; line-height: 16px; margin: 0;"> 
                                    <span style="font-size: 14px"> ผู้ส่ง </span>
                                    <br>
                                    ${senderInfoTxt}
                                </p>
                            </td>

                            <td valign="top">
                                <div style="width: 100%; height: 30px; line-height: 30px; background-color: black; color: white; text-align: center">
                                    ${({ 1: 'Pickup', 2: 'Dropoff' }[order.serviceType]) || ""}
                                </div>

                                <div style="width: 100%; height: 20px; line-height: 20px; color: black; font-size: 8px; text-align: center; border: 1px solid black; box-sizing: border-box;">
                                    ${order.return_first_sort_code}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p style="font-size: 12px; margin: 0">
                                    <span style="font-size: 12px">  ผู้รับ โทร (${cust.phoneNo}) </span>
                                    <br>
                                    ${receiverInfoTxt}
                                </p>
                            </td>
                            <td valign="bottom">
                                <div style="width: 100%; height: 30px; line-height: 30px; background-color: gray; color: white; text-align: center">
                                    ${order.r_first_sort_code.charAt(0).toUpperCase()}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p style="font-size: 8px; margin: 0; column-count: 2; column-gap: 2rem;">
                                    ${order.remarks.replace("หมายเหตุ:", "หมายเหตุ:<br>").replaceAll('\n', '<br>')}
                                </p>
                            </td>
                            <td valign="bottom" style="text-align: center;">
                                    ${order.codAmount ? `COD <br> ฿${order.codAmount}` : "ไม่ต้องเก็บเงิน"}
                            </td>
                        </tr>
                    </table>

                    <table border="1" style="border-collapse:collapse; width: 100%;">
                        <tr>
                            <td style="width: 20%">
                                <img style="margin-bottom: -7px" src="${textToImage({
                bcid: 'qrcode',
                text: order.trackingNo,
                scale: 2,
            })}"/>
                            </td>
                            <td valign="top" style="width: 80%">
                                <div style="position: relative; width: 100%; line-height: 30px; background-color: black; color: white; padding: 4px; box-sizing: border-box;">

                                    <p style="margin: 0; line-height: 20px;">
                                        ${cust.address.district}
                                        <br>
                                        ${order.r_first_sort_code}
                                    </p>
                                    <span style="position: absolute; right: 10px; top: 10px; font-size: 24px;"> NS </span>
                                </div>

                                <div style="width: 100%; line-height: 15px; padding: 4px; box-sizing: border-box; border: 1px solid black; font-size: 12px;">
                                    ทำรายการด้วยระบบ PROSHIP
                                    <br>
                                    ${currentDateTime}
                                </div>

                            </td>
                        </tr>
                    </table>

                    <!-- products -->
                    <p style="margin: 0; font-size: 12px; font-weight: bold; padding-left: 2px;"> รายการสินค้า </p>
                    <table style='font-size: 11px; width: 100%' cellpadding="0" cellspacing="0">
                        ${productsHtml}
                    </table>

                </div>`

            return html
        },

        "flash": () => {
            let cust = order.customer;
            let receiverInfoTxt = [
                `${cust.name} (${cust.phoneNo})`,
                cust.address.address,
                cust.address.subDistrict,
                cust.address.district,
                cust.address.province
            ].filter(a => a && a.length).join("<br>")
            let shop = order.shop;
            let senderInfoTxt = [
                `${shop.name} (${shop.phoneNo})`,
                shop.address.address,
                shop.address.district + ", " + shop.address.subDistrict,
                shop.address.province + ", " + shop.address.zipcode
            ].filter(a => a && a.length).join("<br>")
            let shopSocialLinksTxt = "";
            if (shop.socialLinks) {
                Object.keys(shop.socialLinks).forEach(
                    (key) => (shopSocialLinksTxt += shop.socialLinks[key] + "\n")
                );
            }
            let productsHtml = "";
            let c = 0;
            for (const sku in order.products) {
                if (c % 2 === 0) productsHtml += `<tr>`
                productsHtml += `<td> ${order.products[sku].sku || sku} ${order.products[sku].name} x ${order.products[sku].qty} </td>`;
                if (c % 2 !== 0) productsHtml += `</tr>`
                c++;
            }
            let currentDateTime = new Date().toLocaleString("en-GB", { day: "numeric", month: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(",", "");
            let html = `
        <div style="width: 3.74in; box-sizing: border-box; height: 5.75in; margin: 0.010in; border: 1px solid black; padding: 2px; position: relative;">
        <span style="font-size: 12px;">${currentDateTime}</span>
        <div style="display: flex; align-items: center; justify-content: center;">
        ${order.sortingCode.split("-").map((t, i) => `<span style="font-size: ${i === 1 ? '40px' : '28px'};"> ${t} </span>`).join("&nbsp;-&nbsp;")}
        </div>
        <div style="display: flex; justify-content: center; margin-top: -12px;">
            <img src="${textToImage({
                bcid: "code128",
                text: order.trackingNo,
                scale: 2,
                height: 8,
            })}" width="90%" style="text-align: center" />
        </div>
        <p style="font-size: 20px; margin-top: -2px; margin-bottom: 0; text-align: center;"> ${order.trackingNo} </p>
        <table style="border-collapse:collapse; width: 100%; text-align: center;">
            <tr>
                <td colspan="2" align="left" style="padding-left: 4px; border: 1px solid black;">
                    DST ${order.dstStoreName}
                </td>
            </tr>
            <tr>
                <td style="padding-left: 4px; text-align: left; font-size: 12px; border: 1px solid black;">
                    ผู้ส่ง
                    <br>
                    ${senderInfoTxt}
                </td>
                <td valign="center" style="width: 30%; background-color: black; color: white; font-size: 40px; border: 1px solid black;">
                    ${order.sortingLineCode}
                </td>
            </tr>
            <tr>
                <td colspan="2" align="left" style="padding-left: 4px; font-size: 12px; border: 1px solid black;">
                    ผู้รับ โทร (${cust.phoneNo})
                    <br>
                    ${receiverInfoTxt}
                </td>
            </tr>
        </table>
        ${order.codAmount ? `
            <table style="border-collapse:collapse; width: 100%; text-align: center;">
                <tr>
                    <td style="border: 1px solid black;">เก็บเงินค่าสินค้า</td>
                    <td style="border: 1px solid black;"> COD &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ฿${order.codAmount} </td>
                </tr>
            </table>
            `: ''}
         <p style="margin: 0; font-size: 12px; border: 1px solid black; padding-left: 4px;">
           ${order.remarks}
         </p>
         <table style='font-size: 11px; width: 100%' cellpadding="0" cellspacing="0">
            ${productsHtml}
         </table>
        </div>`
            return html
        },
    }

    let sm = order.shippingMethod
    if (["thaipost", "thaipost0", "jt"].includes(sm) && order.codAmount) sm += "-cod"
    return RENDERER[sm] ? RENDERER[sm]() : "";
}

async function renderAllLabels(orders, format = "normal") {

    let licenseNo = null;
    try {
        const { data } = await http.get("https://x1pukio3fj.execute-api.ap-southeast-1.amazonaws.com/dev/v1/settings/thaipost-user")
        licenseNo = data.licenseNo;
    } catch (e) {
        console.log(e);
    }

    const classByFormat = {
        "normal": "grid-template-columns: 1fr;",
        "a4": "grid-template-columns: repeat(2, 1fr); grid-template-rows: repeat(2, auto)"
    }

    let html = `<div style="display: grid; ${classByFormat[format]}">`;
    for (const order of orders) {
        order.licenseNo = licenseNo;
        try {
            html += generateLabel(order);
        } catch (e) {
            console.log(e);
            continue;
        }
    }
    html += `</div>`;
    return html
}

export const printHtmlLabels = async (orders, format = "normal") => {
    let html = await renderAllLabels(orders, format)

    function OpenPrintReceiptPage(htmlContent) {
        const printWindow = window.open('', '_blank');
        if (printWindow) {
            printWindow.document.open();
            printWindow.document.write(htmlContent);
            printWindow.document.close();
            printWindow.onload = () => {
                printWindow.print();
                // printWindow.close();
            };
        } else {
            console.error('Popup blocked. Allow popups to print the content.');
        }
    }
    OpenPrintReceiptPage(`
<!DOCTYPE HTML>
<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="th" lang="th">
<head>
    <meta http-equiv="Content-Type" content="text/html" charset="UTF-8" />
    <meta http-equiv="Content-Language" content="th_TH" />

    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Fira+Code:wght@300..700&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Kanit:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
          rel="stylesheet">

    <title>Proship - labels</title>
    <body style='font-family: "Kanit", sans-serif;'> ${html} </body> 
</html>`)
}
